import { render, staticRenderFns } from "./GISWMSSwipeMap.vue?vue&type=template&id=5908d485&scoped=true"
import script from "./GISWMSSwipeMap.vue?vue&type=script&lang=js"
export * from "./GISWMSSwipeMap.vue?vue&type=script&lang=js"
import style0 from "./GISWMSSwipeMap.vue?vue&type=style&index=0&id=5908d485&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5908d485",
  null
  
)

export default component.exports